import React, { useState, useContext, useEffect } from 'react';
import MaterialTable from 'material-table';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import tableIcons from "./components/MaterialTableIcons";
import { Form, FormGroup } from 'react-bootstrap';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { api_url } from "./authorize";
import { AuthorizeContext } from './RootContext';

const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
  },
  title: {
    fontSize: '2em'
  }
});

const theme = createTheme({
  typography: { h6: { fontSize: '1.4em' } },
});

const tableStyles = makeStyles({
  root: { justifyContent: 'space-evenly' },
  spacing: { justifyContent: 'space-evenly' }
});

function ARSetup() {
  const { token, role, setAuthBody, setAuthenticated, authBody } = useContext(AuthorizeContext);
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(authBody || { role: "visitor" });
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const tableClass = tableStyles();
  const [tableData, setTableData] = useState([]);
  const [country, setCountry] = useState({});
  const [popupData, setPopupData] = useState({});
  const [hosData, setHosData] = useState([]);
  const [disData, setDisData] = useState([]);
  const [officeCountry, setOfficeCountry] = useState([]);
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = [...tableData];
  };

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setPopupData({});
    setOpen(false);
  };

  const hasRole = (profile, roles) => {
    return roles.includes(role);
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  };

  const SaveChange = (option) => {
    const { name, value } = option.target;

    if (name === "Office_Name") {
      const selectedOffice = disData.find(
        (item) => String(item.mongo_id) === String(value)
      ) || "";
      setPopupData((prev) => ({
        ...prev,
        Office_Name: selectedOffice
      }));
      return;
    }

    if (name === "Hospital_ID") {
      const selectedHospital = hosData.find(
        (item) => String(item.mongo_id) === String(value)
      ) || "";
      setPopupData((prev) => ({
        ...prev,
        Hospital_ID: selectedHospital
      }));
      return;
    }

    setPopupData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios({
        url: `https://${api_url}/api/receivables`,
        method: 'get',
        headers: {
          'x-access-token': token
        }
      }).then(
        res => {
          if (res.data.message) {
            alert(res.data.message);
          }
          else if (res.data.validation) {
            alert(res.data.validation.replace("_", " "));
          }
          else if (res.data.notLoggedIn) {
            setAuthenticated(false);
            setAuthBody({ role: 'visitor' });
            console.log(res.data);
            alert("You have been logged out due to inactivity. Please log in again.");
          }
          else {
            setTableData(Array.isArray(res.data) ? res.data : []);
          }
        }
      );
    };
    fetchData();
  }, [token, setAuthenticated, setAuthBody]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios({
        url: `https://${api_url}/api/big_form_dropdowns`,
        method: 'get',
        headers: {
          'x-access-token': token
        }
      }).then(
        res => {
          if (res.data.message) {
            alert(res.data.message);
          }
          else if (res.data.validation) {
            alert(res.data.validation.replace("_", " "));
          }
          else if (res.data.notLoggedIn) {
            setAuthenticated(false);
            setAuthBody({ role: 'visitor' });
            alert("You have been logged out due to inactivity. Please log in again.");
          }
          else {
            setOfficeCountry(res.data.countries);
          }
        }
      );
    };
    fetchData();
  }, [token, setAuthenticated, setAuthBody]);

  const editTheRow = (ROWdata) => {
    return axios({
      url: `https://${api_url}/api/receivables?mongo_id=${ROWdata._id}`,
      method: 'put',
      data: ROWdata,
      headers: {
        'x-access-token': token
      }
    }).then(
      res => {
        if (res.data.message) {
          alert(res.data.message);
        }
        else if (res.data.validation) {
          alert(res.data.validation.replace("_", " "));
        }
        else if (res.data.notLoggedIn) {
          setAuthenticated(false);
          setAuthBody({ role: 'visitor' });
          alert("You have been logged out due to inactivity. Please log in again.");
        }
        else {
          // FIX:
          // Previously this used:
          // setTableData(Array.isArray(res.data) ? res.data : []);
          //
          // That caused the table to become empty when the backend returned
          // a single object or success response instead of the full array.
          //
          // This keeps the current table and only updates the edited row.
          setTableData((prev) =>
            prev.map((row) =>
              row._id === ROWdata._id ? { ...row, ...ROWdata } : row
            )
          );
        }
      }
    ).catch((error) => {
      console.error(error);
      alert(
        error?.response?.data?.message ||
        error?.response?.data?.validation ||
        "Failed to update row."
      );
    });
  };

  const deleteTheRow = (ROWdata) => {
    return axios({
      url: `https://${api_url}/api/receivables?mongo_id=${ROWdata._id}`,
      method: 'delete',
      headers: {
        'x-access-token': token
      }
    }).then(
      res => {
        if (res.data.message && !res.data.success) {
          alert(res.data.message);
          return;
        }
        else if (res.data.notLoggedIn) {
          setAuthenticated(false);
          setAuthBody({ role: 'visitor' });
          alert("You have been logged out due to inactivity. Please log in again.");
          return;
        }
        else {
          setTableData((prev) => prev.filter((row) => row._id !== ROWdata._id));
        }
      }
    ).catch((error) => {
      console.error(error);
      alert(
        error?.response?.data?.message ||
        "Failed to delete row."
      );
    });
  };

  useEffect(() => {
    const fetchAcct = async () => {
      const res = await axios({
        url: `https://${api_url}/api/receivables?dropdown=true`,
        method: 'get',
        headers: {
          'x-access-token': token
        }
      }).then(
        res => {
          if (res.data.message) {
            alert(res.data.message);
          }
          else if (res.data.validation) {
            alert(res.data.validation.replace("_", " "));
          }
          else if (res.data.notLoggedIn) {
            console.log(res.data);
            alert("You have been logged out due to inactivity. Please log in again.");
          }
          else {
            setHosData(res.data.hos);
            setDisData(res.data.dis);
          }
        }
      );
    };
    fetchAcct();
  }, [token]);

  const handlePost = async (e) => {
    e.preventDefault();

    try {
      const res = await axios({
        url: `https://${api_url}/api/receivables`,
        method: 'post',
        data: popupData,
        headers: {
          'x-access-token': token
        }
      });

      if (res.data.message) {
        alert(res.data.message);
        return;
      }
      if (res.data.validation) {
        alert(res.data.validation.replace("_", " "));
        return;
      }
      if (res.data.notLoggedIn) {
        setAuthenticated(false);
        setAuthBody({ role: 'visitor' });
        alert("You have been logged out due to inactivity. Please log in again.");
        return;
      }

      const refreshRes = await axios({
        url: `https://${api_url}/api/receivables`,
        method: 'get',
        headers: {
          'x-access-token': token
        }
      });

      if (refreshRes.data.notLoggedIn) {
        setAuthenticated(false);
        setAuthBody({ role: 'visitor' });
        alert("You have been logged out due to inactivity. Please log in again.");
        return;
      }

      setTableData(Array.isArray(refreshRes.data) ? refreshRes.data : []);
      setPopupData({});
      setOpen(false);
    } catch (error) {
      console.error(error);
      alert(
        error?.response?.data?.message ||
        error?.response?.data?.validation ||
        "Failed to add new customer."
      );
    }
  };

  const columns = [
    {
      title: 'Account #',
      field: 'Acct_No',
      editable: 'never',
      defaultSort: 'dsc',
      cellStyle: { fontSize: '1em' }
    },
    { title: 'Company Name', field: 'Office_Name', cellStyle: { fontSize: '1em' } },
    { title: 'Hospital Name', field: 'Hospital_Name', cellStyle: { fontSize: '1em' } },
    { title: 'Contact Last Name', field: 'Last_Name', cellStyle: { fontSize: '1em' } },
    { title: 'Contact First Name', field: 'First_Name', cellStyle: { fontSize: '1em' } },
    { title: 'Phone #', field: 'Phone', cellStyle: { fontSize: '1em' } },
    { title: 'Email', field: 'Email_Address', cellStyle: { fontSize: '1em' } },
    { title: 'Address', field: 'Address', cellStyle: { fontSize: '1em' } },
    { title: 'Contract/PO', field: 'PO_number', cellStyle: { fontSize: '1em' } },
    {
      title: 'Currency',
      field: 'currency',
      lookup: {
        'USD': 'USD',
        'KRW': 'KRW',
        'JPY': 'JPY',
        'EUR': 'EUR',
      },
      cellStyle: { fontSize: '1em' }
    },
    {
      title: 'Unit Price',
      field: 'Unit_Price',
      render: (rowData) => (
        <div style={{ textAlign: 'left' }}>
          {numberWithCommas(Number.parseFloat(rowData.Unit_Price).toFixed(2))}
        </div>
      ),
      cellStyle: { fontSize: '1em' }
    },
    {
      title: 'Tax %',
      field: 'Tax',
      render: (rowData) => (
        <div style={{ textAlign: 'left' }}>
          {numberWithCommas(Number.parseFloat(rowData.Tax))}
        </div>
      ),
      cellStyle: { fontSize: '1em' }
    },
    {
      title: 'Term',
      field: 'Term',
      lookup: {
        'N30': 'N30',
        'N45': 'N45',
        'N60': 'N60',
        'N0': 'Due Upon',
      },
      cellStyle: { fontSize: '1em' }
    },
  ];

  return (
    <div className="ARSetup">
      <h1 align="center">A/R SETUP</h1>

      <button onClick={goBack}>
        Back
      </button>

      <ThemeProvider theme={theme}>
        <MaterialTable
          title="Accounts Receivable Setup"
          icons={tableIcons}
          columns={columns}
          data={tableData}
          editable={{
            onRowUpdate: (newRow) => new Promise((resolve, reject) => {
              editTheRow(newRow)
                .then(() => resolve())
                .catch(() => reject());
            }),
            onRowDelete: (oldRow) => new Promise((resolve) => {
              deleteTheRow(oldRow).finally(() => resolve());
            }),
          }}
          actions={[
            {
              icon: tableIcons.Add,
              tooltip: 'Add User',
              isFreeAction: true,
              onClick: () => {
                setPopupData({});
                setOpen(true);
              }
            }
          ]}
          onSelectionChange={(selectedRows) => console.log(selectedRows)}
          options={{
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "outlined",
            filtering: false,
            paging: true,
            pageSizeOptions: [2, 5, 10, 15, 50],
            pageSize: 5,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: {
              csv: true,
            },
            exportAllData: true,
            exportFileName: "TableData",
            addRowPosition: "first",
            actionsColumnIndex: -1,
            selection: false,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: true,
            rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
            headerStyle: { background: "lightgray", fontStyle: "italic", fontSize: 15 },
            selectionProps: rowData => ({
              disabled: rowData.tax === null,
              color: "primary"
            }),
          }}
        />
      </ThemeProvider>

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          <span style={{ fontSize: '2em' }}>NEW CUSTOMER</span>
        </DialogTitle>

        <DialogContent>
          <Form className="arForm">
            <FormGroup>
              <div>
                <div>
                  <label>Distributor*</label>
                </div>
                <div>
                  <Select
                    native
                    name="Office_Name"
                    onChange={SaveChange}
                    style={{ fontSize: '2rem' }}
                    fullWidth
                    required
                    variant="outlined"
                    value={popupData.Office_Name?.mongo_id || ""}
                  >
                    <option value={""}>Choose Office</option>
                    {
                      disData
                        ? disData.map((option) => (
                          <option
                            key={option.mongo_id}
                            value={String(option.mongo_id)}
                          >
                            {`${option.drop_string}`}
                          </option>
                        ))
                        : null
                    }
                  </Select>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Pure_Distributor*</label>
                </div>
                <Select
                  native
                  name="Pure_Distributor"
                  onChange={SaveChange}
                  style={{ fontSize: '2rem' }}
                  fullWidth
                  required
                  defaultValue=""
                  variant="outlined"
                  value={popupData.Pure_Distributor || ""}
                >
                  <option value={""}>Choose </option>
                  <option value="T">True</option>
                  <option value="F">False</option>
                </Select>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Hospital*</label>
                </div>
                <div>
                  <Select
                    native
                    name="Hospital_ID"
                    onChange={SaveChange}
                    style={{ fontSize: '2rem' }}
                    fullWidth
                    required
                    variant="outlined"
                    value={popupData.Hospital_ID?.mongo_id || ""}
                  >
                    <option value={""}>Choose Hospital</option>
                    {
                      hosData
                        ? hosData.map((option) => (
                          <option
                            key={option.mongo_id}
                            value={String(option.mongo_id)}
                          >
                            {`${option.drop_string}`}
                          </option>
                        ))
                        : null
                    }
                  </Select>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Last Name*</label>
                </div>
                <div>
                  <input
                    name="Last_Name"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.Last_Name || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>First Name*</label>
                </div>
                <div>
                  <input
                    name="First_Name"
                    type="text"
                    value={popupData.First_Name || ""}
                    onChange={SaveChange}
                    style={{ fontSize: '2rem' }}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Middle Name</label>
                </div>
                <div>
                  <input
                    name="Middle_Name"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.Middle_Name || ""}
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Phone*</label>
                </div>
                <div>
                  <input
                    name="Phone"
                    type="text"
                    value={popupData.Phone || ""}
                    onChange={SaveChange}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Billing Email Address*</label>
                </div>
                <div>
                  <input
                    name="Email_Address"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.Email_Address || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Street*</label>
                </div>
                <div>
                  <input
                    name="Street"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.Street || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>city*</label>
                </div>
                <div>
                  <input
                    name="City"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.City || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>State/Province</label>
                </div>
                <div>
                  <input
                    name="State"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.State || ""}
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Postal Code*</label>
                </div>
                <div>
                  <input
                    name="Zip_Code"
                    type="text"
                    onChange={SaveChange}
                    value={popupData.Zip_Code || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Country*</label>
                </div>
                <div>
                  <Select
                    native
                    name="Country"
                    onChange={SaveChange}
                    style={{ fontSize: '2rem' }}
                    fullWidth
                    required
                    variant="outlined"
                    value={popupData.Country || ""}
                  >
                    <option value={""}>Choose Country</option>
                    {
                      officeCountry
                        ? officeCountry.map((option) => (
                          <option
                            key={option[1]}
                            value={option[1]}
                          >
                            {`${option[0]}`}
                          </option>
                        ))
                        : null
                    }
                  </Select>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Contract/PO</label>
                </div>
                <div>
                  <input
                    name="PO_number"
                    type="text"
                    value={popupData.PO_number || ""}
                    onChange={SaveChange}
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Currency</label>
                </div>
                <Select
                  native
                  name="currency"
                  onChange={SaveChange}
                  style={{ fontSize: '1.5rem' }}
                  fullWidth
                  required
                  variant="outlined"
                  value={popupData.currency || ""}
                >
                  <option value={""}>Choose Currency</option>
                  <option value="USD">$ (USD)</option>
                  <option value="KRW">₩ (KRW)</option>
                  <option value="JPY">¥ (JPY)</option>
                  <option value="EUR">€ (EUR)</option>
                </Select>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Unit Price</label>
                </div>
                <div>
                  <input
                    name="Unit_Price"
                    type="number"
                    onChange={SaveChange}
                    style={{ fontSize: '2rem' }}
                    value={popupData.Unit_Price || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Tax</label>
                </div>
                <div>
                  <input
                    name="Tax"
                    type="number"
                    onChange={SaveChange}
                    style={{ fontSize: '2rem' }}
                    value={popupData.Tax || ""}
                    required
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Invoice Preference: </label>
                </div>
                <div>
                  <Select
                    native
                    name="Invoice_pref"
                    value={popupData.Invoice_pref || ""}
                    onChange={SaveChange}
                    style={{ fontSize: '1.5rem' }}
                    required
                    variant="outlined"
                  >
                    <option value={""}>Choose Preference</option>
                    <option value="Email">Email</option>
                    <option value="Print">Print</option>
                  </Select>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <div>
                <div>
                  <label>Payment Term*</label>
                </div>
                <Select
                  native
                  name="Term"
                  onChange={SaveChange}
                  style={{ fontSize: '2rem' }}
                  fullWidth
                  required
                  defaultValue=""
                  variant="outlined"
                  value={popupData.Term || ""}
                >
                  <option value={""}>Choose Term</option>
                  <option value="N30">N30</option>
                  <option value="N45">N45</option>
                  <option value="N60">N60</option>
                  <option value="N0">Due Upon</option>
                </Select>
              </div>
            </FormGroup>

            <DialogActions
              disableSpacing
              classes={{
                root: tableClass.root,
                spacing: tableClass.spacing
              }}
            >
              <button
                className="btn btn-success"
                onClick={handlePost}
                variant="contained"
                style={{ fontSize: '2em' }}
              >
                Add
              </button>

              <button
                className="btn btn-danger"
                onClick={handleClose}
                style={{ fontSize: '2em' }}
              >
                Cancel
              </button>
            </DialogActions>
          </Form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ARSetup;